<template>
  <div class='interactive-video'>
    <component :is='currentInteractiveVideo(code)' />

    <div
      class="video-overlay"
      :style='overlay_style'
    >
      <h2 class="video-overlay_headline h-three-light">
        {{ headline }}
      </h2>

      <a
        class="play-btn"
        title="play"
      />
    </div>
  </div>
</template>

<script>
// Blue Zones
import BlueZonesTour from './BlueZonesTour'
import BlueZonesIntro from './BlueZonesIntro'

// University of Minnesotta
import UofM6Dimensions from './UofM6Dimensions'
import UofMConversationsWMaryJo from './UofMConversationsWMaryJo'
import UofMMindfulMeditation from './UofMMindfulMeditation'

// MNCASA
import MNCASAUnderstandingSexualViolence from './MNCASAUnderstandingSexualViolence'
import MNCASAThreeKeysToImproving from './MNCASAThreeKeysToImproving'
import MNCASAStrongPartnerships from './MNCASAStrongPartnerships'
import MNCASAUnderstandingSexualViolenceES from './MNCASAUnderstandingSexualViolenceES'
import MNCASAThreeKeysToImprovingES from './MNCASAThreeKeysToImprovingES'
import MNCASAStrongPartnershipsES from './MNCASAStrongPartnershipsES'

// USBank
import USBankRecognizeMajorScams from './USBankRecognizeMajorScams'
import USBankRecognizeFamilyEmergency from './USBankRecognizeFamilyEmergency'
import USBankProtectCyberscamScenarios from './USBankProtectCyberscamScenarios'
import USBankProtectSuspiciousEmail from './USBankProtectSuspiciousEmail'

// Captivate
import CaptivateOne from './CaptivateOne'
import CaptivateThree from './CaptivateThree'
import CaptivateThreeV2 from './CaptivateThreeV2'

// Cost of Care
import ContainingCostOfCare from './ContainingCostOfCare'

// Diabetes
import DiabetesOne from './DiabetesOne'
import DiabetesSix from './DiabetesSix'

// Dr You
import DrYouTwo from './DrYouTwo'
import DrYouThree from './DrYouThree'
import DrYouSix from './DrYouSix'

import HsaForEveryOccasion from './HsaForEveryOccasion'
import WhatIsFsa from './WhatIsFsa'
import FsaClaimsProcess from './FsaClaimsProcess'

import NpsImprovingCustomerExperienceV1 from './NpsImprovingCustomerExperienceV1'
import Spirituality from './SpiritualityInteractiveVideo'

// Vocational
import VocationalFaithLeaders from './VocationalFaithLeaders'
import VocationalHowOpen from './VocationalHowOpen'
import VocationalSettingBoundaries from './VocationalSettingBoundaries'
import VocationalServingDiversePopulations from './VocationalServingDiversePopulations'
import VocationalCultivatingNewConnections from './VocationalCultivatingNewConnections'
import VocationalCongregationalLeadership from './VocationalCongregationalLeadership'
import VocationalCaringForGodsPeople from './VocationalCaringForGodsPeople'

// UHS Colon Cancer
import UHCColonCancer from './UHC_ColonCancer'

export default {
  props: ['code', 'headline', 'isPlaying'],

  components: {
    BlueZonesTour,
    BlueZonesIntro,

    UofM6Dimensions,
    UofMConversationsWMaryJo,
    UofMMindfulMeditation,

    MNCASAUnderstandingSexualViolence,
    MNCASAThreeKeysToImproving,
    MNCASAStrongPartnerships,
    MNCASAUnderstandingSexualViolenceES,
    MNCASAThreeKeysToImprovingES,
    MNCASAStrongPartnershipsES,

    USBankRecognizeMajorScams,
    USBankRecognizeFamilyEmergency,
    USBankProtectCyberscamScenarios,
    USBankProtectSuspiciousEmail,

    CaptivateOne,
    CaptivateThree,
    CaptivateThreeV2,

    ContainingCostOfCare,

    DiabetesOne,
    DiabetesSix,

    DrYouTwo,
    DrYouThree,
    DrYouSix,

    HsaForEveryOccasion,
    WhatIsFsa,
    FsaClaimsProcess,

    NpsImprovingCustomerExperienceV1,
    Spirituality,

    VocationalFaithLeaders,
    VocationalHowOpen,
    VocationalSettingBoundaries,
    VocationalServingDiversePopulations,
    VocationalCultivatingNewConnections,
    VocationalCongregationalLeadership,
    VocationalCaringForGodsPeople,

    UHCColonCancer
  },

  mounted() {
    // Load Wistia API script
    if (document.querySelector('#wistia_api_script') === null) {
      const wistia_api_script = document.createElement('script')
      wistia_api_script.setAttribute('src', '//fast.wistia.com/assets/external/E-v1.js')
      wistia_api_script.async = true
      wistia_api_script.setAttribute('id', 'wistia_api_script')
      document.head.appendChild(wistia_api_script)
    }
  },

  computed: {
    overlay_style() {
      if (this.isPlaying) return 'display: none'
      return null
    }

  },

  methods: {
    currentInteractiveVideo(code) {
      const videos = {
        bluezones_tour : 'BlueZonesTour',
        bluezones_intro : 'BlueZonesIntro',
        bluezones_intro_short : 'BlueZonesIntro',

        uofm_6_dimensions: 'UofM6Dimensions',
        uofm_conversations_w_mary_jo: 'UofMConversationsWMaryJo',
        uofm_mindful_meditation: 'UofMMindfulMeditation',

        mncasa_understanding_sexual_violence: 'MNCASAUnderstandingSexualViolence',
        mncasa_three_keys_to_improving: 'MNCASAThreeKeysToImproving',
        mncasa_strong_partnerships: 'MNCASAStrongPartnerships',
        mncasa_understanding_sexual_violence_es: 'MNCASAUnderstandingSexualViolenceES',
        mncasa_three_keys_to_improving_es: 'MNCASAThreeKeysToImprovingES',
        mncasa_strong_partnerships_es: 'MNCASAStrongPartnershipsES',

        usbank_recognize_major_scams: 'USBankRecognizeMajorScams',
        usbank_recognize_family_emergency: 'USBankRecognizeFamilyEmergency',
        usbank_protect_cyberscam_scenarios: 'USBankProtectCyberscamScenarios',
        usbank_protect_suspicious_email: 'USBankProtectSuspiciousEmail',

        captivate_1_1: 'CaptivateOne',
        captivate_3_3: 'CaptivateThree',
        captivate_3_3v2: 'CaptivateThreeV2',

        containing_cost_of_care: 'ContainingCostOfCare',

        diabetes_1_1: 'DiabetesOne',
        diabetes_6_3: 'DiabetesSix',

        dr_you_2_1: 'DrYouTwo',
        dr_you_3_1: 'DrYouThree',
        dr_you_6_1: 'DrYouSix',

        hsa_for_every_occasion: 'HsaForEveryOccasion',
        what_is_fsa: 'WhatIsFsa',
        fsa_claims_process: 'FsaClaimsProcess',

        'nps-improving_customer_experience-v1': 'NpsImprovingCustomerExperienceV1',

        spirituality: 'Spirituality',

        vocational_faith_leaders: 'VocationalFaithLeaders',
        vocational_how_open: 'VocationalHowOpen',
        vocational_setting_boundaries: 'VocationalSettingBoundaries',
        vocational_serving_diverse_populations: 'VocationalServingDiversePopulations',
        vocational_cultivating_new_connections: 'VocationalCultivatingNewConnections',
        vocational_congregational_leadership: 'VocationalCongregationalLeadership',
        vocational_caring_for_gods_people: 'VocationalCaringForGodsPeople',

        uhc_colon_cancer: 'UHCColonCancer'
      }

      return videos[code]
    }
  }
}
</script>

<style lang='sass' scoped>
.play-btn
  width: 66px
  height: 66px
  display: block
  margin-top: 20px
  background-image: url('video_play.png')
  background-size: 100%
  background-position: center center
  background-repeat: no-repeat
  z-index: 2
  cursor: pointer

  @media (max-width: 1023px)
    width: 45px
    height: 45px

  @media (max-width: 740px)
    margin-top: 12px
    width: 36px
    height: 36px

  img
    display: block
    max-width: 100%

.video-overlay
  position: absolute
  top: 0
  right: 0
  left: 0
  bottom: 34px
  height: auto
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column

  .video-overlay_headline
    z-index: 2
    width: 85%
    margin: 0 auto
    padding: 0
    box-sizing: border-box
</style>
